/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Style_Guide_Manager_Total_Characters_LabelInputs */



/**
* | output |
* | --- |
* | "Total Characters" |
*
* @param {Style_Guide_Manager_Total_Characters_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const style_guide_manager_total_characters_label = /** @type {((inputs?: Style_Guide_Manager_Total_Characters_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Style_Guide_Manager_Total_Characters_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Total des caracteres")
	if (locale === "de") return /** @type {LocalizedString} */ ("Gesamtanzahl Zeichen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Numero totale di personaggi")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Общее количество символов")
	if (locale === "es") return /** @type {LocalizedString} */ ("Caracteres totales")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("总字符数")
	if (locale === "ja") return /** @type {LocalizedString} */ ("合計文字数")
	if (locale === "hi") return /** @type {LocalizedString} */ ("कुल अक्षर")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Total de caracteres")
	return /** @type {LocalizedString} */ ("Total Characters")
});